// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_ciP","title":"Info_title__1u4wI","selects":"Info_selects__i4mvz","requiredAsterisk":"Info_requiredAsterisk__1_Kp8"};